<template>
    <div class="NodeFooterEditor" v-if="isEdit">
        <v-menu offset-y top>
            <template v-slot:activator="{ on }">
                <div v-on="on" class="btn-menu">
                    <v-icon color="#fff">mdi-plus</v-icon>
                </div>
            </template>
            <v-list>
                <v-list-tile v-for="(item, index) in items" :key="index" @click="menuSelect(item)">
                    <v-list-tile-title>{{ item.text | capitalize }}</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
import { mapState } from "vuex";
import ScenarioService from "@/services/scenario.service";

const {NodeEditorMenuCode} = ScenarioService

export default {
    name: "NodeFooterEditor",
    props: {
        actionsNotUse: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        ...mapState({
            scenarioSetting: state => state.scenario.scenario_setting
        }),
        items () {
            let menu = [
                {
                    text: `${this.$t('add')} ${this.$t('setting')}`,
                    value: NodeEditorMenuCode.ADD_SETTING
                },
                {
                    text: `${this.$t('add')} ${this.$t('audio_engine')}`,
                    value: NodeEditorMenuCode.ADD_AUDIO_ENGINE
                },
                {
                    text: `${this.$t('add')} ${this.$t('userAttribute')}`,
                    value: NodeEditorMenuCode.ADD_SET_USER_ATTRIBUTE
                },
                {
                    text: `${this.$t('add')} API`,
                    value: NodeEditorMenuCode.ADD_API
                },
                {
                    text: `${this.$t('add')} LUA script`,
                    value: NodeEditorMenuCode.ADD_LUA
                },
                {
                    text: `${this.$t('clone')} ${this.$t('from')} node`,
                    value: NodeEditorMenuCode.CLONE_NODE
                }
            ]
            if (this.scenarioSetting.version > 1) {
                menu.unshift({
                    text: `${this.$t('add')} ${this.$t('llmClassifier')}`,
                    value: NodeEditorMenuCode.ADD_LLM_CLASSIFIER
                })
                menu.unshift({
                    text: `${this.$t('add')} ${this.$t('nlpConfig')}`,
                    value: NodeEditorMenuCode.ADD_NLP_CONFIG
                })
            }
            if (this.actionsNotUse.length > 0) {
                menu = menu.filter(i => !this.actionsNotUse.includes(i.value))
            }
            return menu
        },
        isEdit () {
            return ScenarioService.isEditable() && ScenarioService.isModeEditing()
        }
    },
    methods: {
        menuSelect (item) {
            this.$emit('menuSelect', item.value)
        }
    }
}
</script>

<style scoped lang="scss">
.NodeFooterEditor {
    z-index: 6;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    width: 40px;
    background: #0052CC;
    border-radius: 10px;
    cursor: pointer;

    .btn-menu {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
